import {IQueryUsersRequestParams, IQueryUsersResponse, Stamp, UserModel, UserPortrait} from '@core/api/data-access';

export interface IStateUser {
	id: string;
	user?: UserModel;
	portrait?: UserPortrait;
	stamps?: Stamp[];
	loadingState?: 'loading' | 'success' | 'error';
}

export interface IUsersGlobalState {
	// Query
	lastQueryRequest?: IQueryUsersRequestParams;
	lastQueryResponse?: Omit<IQueryUsersResponse, 'users'>;
	lastUpdate?: Date;
	loading?: boolean;
	error?: boolean;
}

export const usersGlobalInitialState: IUsersGlobalState = {
	lastUpdate: new Date(),
	loading: false,
	error: false,
};
